import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { sessionKey } from "./useSession";

/** Landing page after the IdP redirect: refresh the session and continue. */
export function AuthCallbackPage() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { t } = useTranslation();
  useEffect(() => {
    void qc.invalidateQueries({ queryKey: sessionKey }).then(() => {
      navigate(params.get("next") ?? "/", { replace: true });
    });
  }, [qc, navigate, params]);
  return <p className="bt-page-message">{t("app.loading")}</p>;
}
